import * as React from 'react';
import { useSelector } from 'react-redux';
import { Actual, TooltipContent, Warning } from '../../components/PriceRelevance';
import { getPriceRelevance } from '../../selectors/newbuilding';
import { EType } from '../../types/newbuilding/priceRelevance';
import { trackHover } from './tracking';
import { WarningTooltip } from './WarningTooltip';

export const PriceRelevance = () => {
  const tooltip = useSelector(getPriceRelevance);

  if (!tooltip) {
    return null;
  }

  if (tooltip.type === EType.Warning) {
    return <Warning label={tooltip.label} tooltip={<WarningTooltip />} />;
  }

  return (
    <Actual
      label={tooltip.label}
      title={tooltip.title}
      description={<TooltipContent description={tooltip.description} tracking={trackHover} />}
    />
  );
};

PriceRelevance.displayName = 'PriceRelevance';
